/**
 * Created by Ivan on 18.04.2024
 */

const StickersBookToolbarItem = function () {
    if (cleverapps.config.features.includes("season_collections")) {
        delete ToolbarItem.STICKERS_BOOK.force;
    }

    ToolbarItem.call(this, ToolbarItem.STICKERS_BOOK);

    this.enable();

    cleverapps.stickersBook.onChangeAttentionListener = this.onChangeState.bind(this);
    this.onChangeState();
};

StickersBookToolbarItem.prototype = Object.create(ToolbarItem.prototype);
StickersBookToolbarItem.prototype.constructor = StickersBookToolbarItem;

StickersBookToolbarItem.prototype.onChangeState = function () {
    if (cleverapps.stickersBook.hasAttention()) {
        this.mark();
    } else {
        this.unmark();
    }
};

StickersBookToolbarItem.prototype.onClick = function () {
    const activeTutorial = cleverapps.tutorial.getActive();

    cleverapps.focusManager.display({
        focus: "StickersBook",
        stack: StickersBookStartTutorial && activeTutorial && activeTutorial.name === StickersBookStartTutorial.NAME,
        action: function (f) {
            cleverapps.tutorial.trigger("stickers_book_toolbar_item_clicked");

            cleverapps.focusManager.onceNoWindowsListener = f;
            new StickersBookWindow(cleverapps.stickersBook);
        }
    });
};

StickersBookToolbarItem.prototype.isVisible = function () {
    return cleverapps.stickersBook.isAvailable();
};
